import { Compiler, Injectable, Injector, NgModuleFactory, NgModuleRef } from '@angular/core';
import type { B2bConfiguratorModule, ConfiguratorsRepositoryService } from './b2b-configurator.module';

@Injectable({
    providedIn: 'root',
})
export class ConfiguratorLoaderService {
    configuratorModuleRef: NgModuleRef<B2bConfiguratorModule>;
    configuratorsRepositoryService: ConfiguratorsRepositoryService;
    configuratorsRepositoryServiceStatic: typeof ConfiguratorsRepositoryService;

    constructor(private compiler: Compiler, private injector: Injector) {
    }

    async loadConfigurator() {
        if (!this.configuratorModuleRef) {
            const {B2bConfiguratorModule: module, ConfiguratorsRepositoryService: service} = await import('./b2b-configurator.module');
            const moduleFactory = await this.loadModuleFactory(module);
            this.configuratorModuleRef = moduleFactory.create(this.injector);
            this.configuratorsRepositoryService = this.configuratorModuleRef.injector.get(service);
            this.configuratorsRepositoryServiceStatic = service;
        }
        return this.configuratorModuleRef;
    }

    private async loadModuleFactory(t: (typeof B2bConfiguratorModule | NgModuleFactory<B2bConfiguratorModule>)) {
        if (t instanceof NgModuleFactory) {
            return t;
        } else {
            return await this.compiler.compileModuleAsync(t);
        }
    }
}
